import { url } from '../../../../../utils/urls';


export const EmojiCategories = ['COLOR_3D', 'BLACK_AND_WHITE_3D', 'COLOR_2D', 'BLACK_AND_WHITE_2D'];

export const EmojiCategoriesTitles = {
  COLOR_3D: '3D Color',
  BLACK_AND_WHITE_3D: '3D Black and White',
  COLOR_2D: '2D Color',
  BLACK_AND_WHITE_2D: '2D Black and White',
};

export const DefaultEmojiCategory = 'COLOR_3D'

// Emojis should be moved to BE but ...

export const Emojis = [
  {
    title: "like",
    name: "upvote",
    COLOR_2D: "upvote-2d.svg",
    BLACK_AND_WHITE_2D: "upvote-g-2d.svg",
    BLACK_AND_WHITE_3D: "upvote-g.svg",
    COLOR_3D: "upvote.svg"
  },
  {
    "name": "downvote",
    COLOR_2D: "downvote-2d.svg",
    "BLACK_AND_WHITE_2D": "downvote-g-2d.svg",
    "BLACK_AND_WHITE_3D": "downvote-g.svg",
    "COLOR_3D": "downvote.svg"
  },
  {
    name: 'love',
    COLOR_2D: 'love-2d.svg',
    BLACK_AND_WHITE_2D: 'love-g-2d.svg',
    BLACK_AND_WHITE_3D: 'love-g.svg',
    COLOR_3D: 'love.svg'
  },
  {
    name: 'funny',
    COLOR_2D: 'funny-2d.svg',
    BLACK_AND_WHITE_2D: 'funny-g-2d.svg',
    BLACK_AND_WHITE_3D: 'funny-g.svg',
    COLOR_3D: 'funny.svg'
  },
  {
    name: 'angry',
    COLOR_2D: 'angry-2d.svg',
    BLACK_AND_WHITE_2D: 'angry-g-2d.svg',
    BLACK_AND_WHITE_3D: 'angry-g.svg',
    COLOR_3D: 'angry.svg'
  },
  {
    name: 'sad',
    COLOR_2D: 'sad-2d.svg',
    BLACK_AND_WHITE_2D: 'sad-g-2d.svg',
    BLACK_AND_WHITE_3D: 'sad-g.svg',
    COLOR_3D: 'sad.svg'
  },
  {
    name: 'curious',
    COLOR_2D: 'curious-2d.svg',
    BLACK_AND_WHITE_2D: 'curious-g-2d.svg',
    BLACK_AND_WHITE_3D: 'curious-g.svg',
    COLOR_3D: 'curious.svg'
  },
  {
    name: 'thoughtful',
    COLOR_2D: 'thoughtful-2d.svg',
    BLACK_AND_WHITE_2D: 'thoughtful-g-2d.svg',
    BLACK_AND_WHITE_3D: 'thoughtful-g.svg',
    COLOR_3D: 'thoughtful.svg'
  },
].map(e => ({
  ...e,
  COLOR_2D: `${url.sentiment}/${e.COLOR_2D}`,
  BLACK_AND_WHITE_2D: `${url.sentiment}/${e.BLACK_AND_WHITE_2D}`,
  BLACK_AND_WHITE_3D: `${url.sentiment}/${e.BLACK_AND_WHITE_3D}`,
  COLOR_3D: `${url.sentiment}/${e.COLOR_3D}`,
}));

export const getEmoji = (name) => Emojis.find(e => e?.name?.toLowerCase() === name?.toLowerCase()) || null;

export const getEmojiIcon = ({ emojiName, emojiCategoryType }) =>
  (Emojis?.find(e => e?.name?.toLowerCase() === emojiName?.toLowerCase()) || {})[emojiCategoryType || DefaultEmojiCategory];
